// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__wz3Z7","col":"styles_col__12MJl"};